import React from 'react';
import { hasRole } from '../api/auth';

export default function CatalogSearchTools({ result, className }) {
    if (result?.engine !== 'v3' || !hasRole('ADMIN') || !result.search_tools?.length) return null;
    return <p className={className} aria-label="Использованные средства поиска">
        Поиск: {result.search_tools.join(' → ')}.
    </p>;
}
